import QuoteRequestListView from '@Views/Quotes/QuoteRequestListView';

const QuoteRequests = (props) => {
    return (
        <>
            {props.QuoteRequestsSubmenus &&
                props.QuoteRequestsSubmenus.filter(submenu => submenu.Key == props.activeTab).map(submenu =>
                    <div className="tab-content active" id="content-5a">
                        <div className="notification-header">
                            <h2 className='mobile-hide'>{submenu.Title}</h2>
                        </div>
                        <QuoteRequestListView {...props} />
                    </div>)}
            {!props.QuoteRequestsSubmenus && 
                <div className="tab-content active" id="content-5a">
                    <div className="notification-header">
                        <h2 className='mobile-hide'>{props.DisplayHeader}</h2>
                    </div>
                    <QuoteRequestListView {...props} />
                </div>}
        </>
    );
};

export default QuoteRequests;